<template>
    <div>
        <el-cascader :size="size" :value="value1"
                     :options="bumendata"
                     :props="props"
                     ref="bumenref"
                     placeholder="请选择部门"
                     @change="handleChange" clearable style="width: 100%;"></el-cascader>
    </div>
</template>

<script>
import { departmentTree,departmentSelfTree } from '@/api/department'
import {getParentIds} from '@/utils/common'
export default {
    name: '',
    props: {
        value: {
            /*type: Array,
            default: function () {
                return [1]
            }*/
            default: null
        },
        self: {
            type: Boolean,
            default: false
        },
        serviceCode: {
            type: String,
            default: 'SYS-USER'
        },
        size:{
            default:'normal'
        }
    },
    data() {
        return {
            bumendata: [],
            props: {
                // expandTrigger: 'hover',
                value: 'id',
                label: 'name',
                children: 'child',
                checkStrictly: true
            },
            // value1: [],
            // modalKey: 0
        }
    },
    methods: {
        getDepartmentTree() {
            departmentTree({serviceCode: this.serviceCode}).then(response => {
                console.log('部门列表',response.data)
                if(response.code!=200)  {
                    return this.$message.error(response.msg)
                }
                this.bumendata = response.data
            })
        },
        handleChange(val) {
            // console.log(val)
            var label = ''
            if(this.$refs.bumenref.getCheckedNodes()[0]){
                label=this.$refs.bumenref.getCheckedNodes()[0].pathLabels
            }
            // console.log('区域级联组件点击信息',val,label)
            this.$emit('nodeChange', val,label)
        },
        getDepartmentSelfTree() {
            departmentSelfTree().then(response => {
                console.log('部门列表-self',response.data)
                if(response.code!=200)  {
                    return this.$message.error(response.msg)
                }
                this.bumendata = response.data
            })
        }
    },
    created() {
        if(this.self){
            this.getDepartmentSelfTree()
        }else{
            this.getDepartmentTree()
        }
    },
    computed: {
        value1(){
            return getParentIds(this.bumendata, this.value)
        }
    },
    watch: {
        // value: {
        //     handler: function () {
        //         this.value1 = getParentIds(this.bumendata, this.value)
        //         console.log(this.value,this.value1)
        //     }
        // }
        /*ancestors: {
            handler: function () {
                // this.ancestors1 = this.ancestors
                this.value1 = this.ancestors.toString().split(',').map(Number)
                this.modalKey++
                console.log('赋值后',this.value1,this.modalKey)
            },
            deep: true
        }*/
    }
}
</script>

<style scoped>

</style>
